module.exports = __webpack_public_path__ + "img/question14c2.34bc141c.png";